"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SitePublishServiceMessage = void 0;
const site_version_1 = require("./site-version");
/**
 * Union of any messages produced to or consumed from the Event Bus by
 * `@backstage-services/site-publish`.
 */
exports.SitePublishServiceMessage = site_version_1.SiteVersionMessage;
